import React from 'react';
import { motion } from 'framer-motion';
import { Trans } from 'react-i18next';
import { services } from '../data/services';

const ServicesSection: React.FC = () => {
  return (
    <section id="services" className="py-20 bg-primary-light dark:bg-primary-dark relative overflow-hidden">
      <div className="container mx-auto px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-bold mb-4">
            <Trans>services.title</Trans>
          </h2>
          <p className="text-gray-600 dark:text-gray-400 text-lg">
            <Trans>services.subtitle</Trans>
          </p>
        </motion.div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {services.map((service, idx) => {
            const Icon = service.icon;
            return (
              <motion.div
                key={service.titleKey}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.7, delay: idx * 0.1 }}
                className="bg-white/50 dark:bg-black/50 backdrop-blur-sm p-8 rounded-xl shadow-lg text-center hover:-translate-y-2 hover:bg-white/60 dark:hover:bg-black/60 transition-transform duration-300"
              >
                <div className="flex justify-center mb-6">
                  <Icon className="h-12 w-12 text-accent" />
                </div>
                <h3 className="text-2xl font-semibold mb-2">
                  <Trans>{service.titleKey}</Trans>
                </h3>
                <p className="text-gray-600 dark:text-gray-400">
                  <Trans>{service.descriptionKey}</Trans>
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
